export const LEGAL_DOCS = {
  en: {
    terms: `# Terms of Use (CGU)

**Jolkia** provides personalized sports coaching based on automated analysis of your training data (distance, duration, heart rate, elevation, perceived effort, etc.).

These analyses may use algorithmic and artificial intelligence technologies to generate training plans, post-workout feedback, and load adjustments. You acknowledge that this automated processing is essential to the service. Without it, Jolkia cannot provide its core features.

## Medical disclaimer

Jolkia does not provide medical advice. Recommendations are not a medical opinion, diagnosis, or prescription. You remain solely responsible for your sports practice and must consult a healthcare professional if needed.
`,
    termsSales: `# Terms of Sale (CGV)

This page describes pricing, billing, trials, and cancellation conditions when a paid offer is available.

> Placeholder: replace with your actual CGV content.
`,
    privacy: `# Privacy Policy

## Purpose and legal basis

Personal and training data are processed to provide the contractual coaching service offered by Jolkia (GDPR Article 6.1(b)).

This includes:
- automated analysis of training sessions,
- generation of personalized plans,
- adaptation of programs based on performance and feedback.

## Sub-processors (AI providers)

Some data may be transmitted to technical service providers acting as processors (including AI service providers). They process data only on Jolkia instructions, strictly to generate personalized content, and are not authorized to use it for other purposes.
`,
    aiDataUsage: `# AI Data Usage

Jolkia relies on automated analysis (including AI) of your training data to deliver the service. This processing is described in the Terms of Use and the Privacy Policy.

> Placeholder: add any additional details about models, retention, and security.
`
  },
  fr: {
    terms: `# Conditions Générales d'Utilisation (CGU)

**Jolkia** propose un accompagnement sportif personnalisé reposant sur l’analyse automatisée des données d’entraînement fournies par l’utilisateur (distance, durée, fréquence cardiaque, dénivelé, sensations, etc.).

Ces analyses peuvent être réalisées à l’aide de technologies algorithmiques et d’intelligence artificielle, permettant notamment de générer des plans d’entraînement, des retours post-séance et des ajustements de charge.

L’utilisateur reconnaît que ce traitement automatisé est indispensable au fonctionnement du service. Sans celui-ci, Jolkia ne serait pas en mesure de fournir les fonctionnalités principales proposées.

## Limitation médicale

Jolkia ne fournit pas de conseils médicaux. Les analyses et recommandations proposées ne constituent en aucun cas un avis médical, un diagnostic ou une prescription.

L’utilisateur demeure seul responsable de sa pratique sportive et s’engage à consulter un professionnel de santé en cas de doute, de douleur ou de problème médical.
`,
    termsSales: `# Conditions Générales de Vente (CGV)

Cette page décrit la tarification, la facturation, les essais et les conditions de résiliation lorsqu’une offre payante est proposée.

> Placeholder : remplacez par vos CGV réelles.
`,
    privacy: `# Politique de confidentialité

## Finalités et base légale

Les données personnelles et sportives collectées sont traitées afin de permettre l’exécution du service contractuel de coaching personnalisé proposé par Jolkia (article 6.1.b du RGPD).

Ces traitements incluent notamment :
- l’analyse automatisée des séances d’entraînement,
- la génération de plans d’entraînement personnalisés,
- l’adaptation du programme en fonction des performances et retours utilisateur.

## Sous-traitants (prestataires IA)

Dans le cadre de la fourniture du service, certaines données peuvent être transmises à des prestataires techniques agissant en qualité de sous-traitants, notamment des fournisseurs de services d’intelligence artificielle.

Ces prestataires traitent les données uniquement selon les instructions de Jolkia, à des fins strictement limitées à l’analyse et à la génération de contenus personnalisés, et ne sont pas autorisés à les utiliser à d’autres fins.
`,
    aiDataUsage: `# Usage des données & IA

Jolkia repose sur l’analyse automatisée (y compris via IA) de vos données d’entraînement pour délivrer le service. Ce traitement est décrit dans les CGU et la Politique de confidentialité.

> Placeholder : ajoutez des détails (modèles, conservation, sécurité) si nécessaire.
`
  }
};

export function getLegalDoc(language, key) {
  const lang = language && language.startsWith('fr') ? 'fr' : 'en';
  const docs = LEGAL_DOCS[lang] || LEGAL_DOCS.en;
  return docs[key] || '';
}


